import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup,FormArray, FormBuilder, NgForm } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoNotificationService, PoPageSlideComponent, PoTableColumn } from '@po-ui/ng-components';
import { defaultProcessoCadastro, ProcessoCadastro } from 'src/app/administrativo/interface/processo-cadastro';
import { Caracteristica, defaultCaracteristica, defaultProcessoPreCadastroProdutoPdm, ProcessoPreCadastroProdutoPdm, ProcessoPreCadastroProdutoPdmDto } from 'src/app/administrativo/interface/processo-pre-cadastro-produto-pdm';
import { PdmService } from 'src/app/administrativo/service/pdm-service';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';
import { AuthService } from 'src/app/service/auth.service';
import { UtilService } from 'src/app/service/util';
import { UtilArquivo } from 'src/app/util/arquivo/util-arquivo.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pre-cadastro-produto-crud-pdm',
  templateUrl: './pre-cadastro-produto-crud-pdm.component.html',
  styleUrl: './pre-cadastro-produto-crud-pdm.component.css'
})
export class PreCadastroProdutoCrudPdmComponent implements OnInit {

  preProdutoPdm: ProcessoPreCadastroProdutoPdm = defaultProcessoPreCadastroProdutoPdm();
  processoCadastro: ProcessoCadastro = defaultProcessoCadastro();

  usuarioLogado: string = '';
  fileChave: string = '';
  fileAlias: string = 'IMGPRODUTO';

  usuarioSolicitante: boolean = false;
  usuarioEngenharia: boolean = false;
  usuarioCompras: boolean = false;
  usuarioControladoria: boolean = false;

  bloqueiaDadosSolicitante: boolean = true;
  bloqueiaDadosCompras: boolean = true;
  bloqueiaDadosControladoria: boolean = true;

  liberaAvancarProcesso: boolean = true;

  urlApiProtheus: string = environment.urlApiProtheus;

  tabelaHistorico: Array<any> = [];

  numIgnorarChange: number = 0;

  historico: string = '';
  urgente: string = 'N';

  caracteristicasForm: FormGroup;

  filterZC1 = {CZC1CODZC0: '', combobox: 'S'};
  filterZC2 = {CZC2CODZC1: '', combobox: 'S'};
  filterPDM = {};
  filterZC4: Array<any> = [];
  filterPDMCombo = {CPDM: '', combobox: 'S'};
  filterZAN = {combobox:'S', CZANCLASOL: '5', CZANGRUPO: ''};
  contadorChanges: number = 0;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Pré-cadastro Produto PDM'},
    ],
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
    private utilService: UtilService,
    private authService: AuthService,
    private processoCadastroService: ProcessoCadastroService,
    private pdmService: PdmService,
    private fb: FormBuilder,
  ) {
    this.caracteristicasForm = this.fb.group({
      items: this.fb.array([]) ,
    });
  }

  @ViewChild('formPrincipal', { static: true }) formPrincipal!: NgForm;
  @ViewChild('utilArquivo', { static: true }) utilArquivo!: UtilArquivo;
  @ViewChild('anexoPageSlide', { static: true }) anexoPageSlide!: PoPageSlideComponent;

  ngOnInit(): void {
    this.usuarioLogado = localStorage.getItem('CUSRID') || '';
    this.fileChave = this.utilService.getUniqueId(4);

    this.activatedRoute.params.subscribe({
      next : (params) => {
        if ('NPROCESSOCODIGO' in params && 'NCODIGO' in params) {
          this.loadDados(params.NPROCESSOCODIGO, params.NCODIGO)
        } else {
          this.bloqueiaDadosSolicitante = false;
          this.contadorChanges = 3;
        }
      },error: () => {
        this.poNotificationService.warning('Dados de acesso inválidos!');
        this.goLista();
      }
    })
  }

  loadDados(NPROCESSOCODIGO: number, NCODIGO: number):void{

    this.processoCadastroService.getProcCadastro(NPROCESSOCODIGO).subscribe({
      next: (ret) => {
        this.processoCadastro = ret;

        this.urgente = ret.CURGENTE;

        this.usuarioSolicitante = (this.processoCadastro.CCODIGOUSUARIOPROTHEUS === this.usuarioLogado);

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_COMPRAS']).then((temPermissao) => {
          this.usuarioCompras = temPermissao;
        });

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_CONTROLADORIA']).then((temPermissao) => {
          this.usuarioControladoria = temPermissao;
        });

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_ENGENHARIA']).then((temPermissao) => {
          this.usuarioEngenharia = temPermissao;
          this.liberaTela();
        });

      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroPreProdutoPdm(NCODIGO).subscribe({
      next: (ret) => {

        this.filterZC1 = { CZC1CODZC0: ret.CGRPNVL1, combobox: 'S' };
        this.filterZC2 = { CZC2CODZC1: ret.CGRPNVL2, combobox: 'S' };
        this.filterPDM = { CPDM: ret.CB1XPDM };
        this.filterPDMCombo = { CPDM: ret.CB1XPDM, combobox: 'S' };
        this.preProdutoPdm = {...defaultProcessoPreCadastroProdutoPdm(), ...ret};

        this.preProdutoPdm.ACARACTERISTICAS.map((item) => {
          this.caracteristicas.push(this.fb.group({...defaultCaracteristica(), ...item}));
          this.filterZC4.push({ CZC4CODZC2: this.preProdutoPdm.CB1XPDM, CZC4CODZC3: item.CCODCARACT });
        });

        if (this.preProdutoPdm.CB1COD){
          this.fileChave = this.preProdutoPdm.CB1COD;
        } else {
          this.fileChave = `PRE${NCODIGO}`;
        }
      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroHistoricoLista(NPROCESSOCODIGO).subscribe({
      next: (historico) => {
        this.tabelaHistorico = historico.items;
      }
    })

  }

  liberaTela():void{
    if (['1','4'].includes(this.processoCadastro.CSTATUS) && this.usuarioEngenharia){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '2' && this.usuarioSolicitante){
      this.bloqueiaDadosSolicitante = false;
    } else if (['3','6'].includes(this.processoCadastro.CSTATUS) && this.usuarioCompras){
      this.bloqueiaDadosCompras = false;
    } else if (['5','8'].includes(this.processoCadastro.CSTATUS) && this.usuarioControladoria){
      this.bloqueiaDadosSolicitante = false;
      this.bloqueiaDadosCompras = false;
      this.bloqueiaDadosControladoria = false;
    } else {
      this.liberaAvancarProcesso = false;
    }
  }

  gravarDados(decisao: string):void{
    this.preProdutoPdm.CB1SEGUM = this.preProdutoPdm.CB1SEGUM == undefined ? "" : this.preProdutoPdm.CB1SEGUM;
    this.preProdutoPdm.ACARACTERISTICAS = this.caracteristicas.value;

    const dados: ProcessoPreCadastroProdutoPdmDto = {
      CURGENTE: this.urgente,
      PRODUTO: this.preProdutoPdm,
      CHISTORICO: this.historico,
      CDECISAO: decisao,
      CARQUIVOSCHAVE: this.fileChave,
    };

    if (this.processoCadastro.NCODIGO <= 0) {
      this.processoCadastroService.postProdutosSimilares(dados).subscribe({
        next: (ret: any) => {
          if (ret.count > 0) {
            let listaItens = '';
            ret.items.forEach((item: any, index: number) => {
              listaItens += `${index + 1} - CÓDIGO: ${item.CODIGO} | DESCRIÇÃO: ${item.DESCRICAO}<br>`;
            });

            this.poDialogService.alert({
              title: `ATENÇÃO - Foram Encontrados Produtos Similares`,
              message: `${listaItens}`,
              ok: () => {
                this.poDialogService.confirm({
                  title: 'Deseja Continuar Mesmo Assim?',
                  message: ret.message,
                  confirm: () => {
                    this.processoCadastroService.postProcCadastroPreProdutoPdm(dados).subscribe({
                      next: () => {
                        this.poNotificationService.success({
                          message: 'Produto cadastrado com sucesso!',
                          duration: 3000
                        });
                        this.goLista()
                      }
                    });
                  },
                  cancel: () => {
                    this.poNotificationService.warning({
                      message: 'Cadastro não realizado. Verifique os produtos similares.',
                      duration: 5000
                    });
                  }
                });
              }
            });
          } else {
            this.processoCadastroService.postProcCadastroPreProdutoPdm(dados).subscribe({
              next: () => {
                this.poNotificationService.success({
                  message: 'Produto alterado com sucesso!',
                  duration: 3000
                });
                this.goLista()
              }
            });
          }
        },
        error: (err) => {
          this.poNotificationService.error({
            message: 'Erro ao verificar produtos similares: ' + (err.error?.message || 'Erro desconhecido'),
            duration: 5000
          });
        }
      });
    } else {
      this.processoCadastroService.postProcCadastroPreProdutoPdm(dados).subscribe({
        next: () => this.goLista()
      });
    }
  }

  confirmarTela():void{

    if(this.preProdutoPdm.CB1SEGUM != undefined && this.preProdutoPdm.CB1SEGUM !== "" && this.preProdutoPdm.NB1CONV == 0){
      this.poNotificationService.warning("O valor do campo Fator de Conversão de UM é inferior ao valor MÍNIMO permitido. (0.00000001)");
      return
    }

    if (this.formPrincipal.valid){
      let texto = '';
      if (this.processoCadastro.NCODIGO <= 0){
        texto = 'Deseja incluir a solicitação de cadastro de produto?'
      } else {
        texto = 'Deseja aprovar a solicitação de cadastro de produto?'
      }

      this.poDialogService.confirm({
        title: 'Avançar Processo',
        message: texto,
        confirm: () =>{
          this.gravarDados('A');
        }
      })
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }

  }

  cancelarRecusarTela():void{
    if (this.processoCadastro.CSTATUS){
      if (this.historico){
        this.poDialogService.confirm({
          title: 'Recusar processo',
          message: 'Deseja Recusar o cadastro deste Produto?',
          confirm: () =>{
            this.gravarDados('R');
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Informe uma observação para poder recusar o cadastro do produto.',
          duration: 5000
        })
      }
    } else {
      this.poDialogService.confirm({
        title: 'Cancelar Solicitação',
        message: 'Deseja sair da tela e cancelar a solicitação de cadastro de produto?',
        confirm: () =>{
          this.goLista();
        }
      })
    }
  }

  encerrarProcesso():void{
    if (this.historico){
      this.poDialogService.confirm({
        title: 'Encerrar Processo',
        message: 'Deseja ENCERRAR o processo?',
        confirm: () =>{
          this.gravarDados('E');
        }
      })
    } else {
      this.poNotificationService.warning({
        message: 'Informe uma observação para poder ENCERRAR o processo.',
        duration: 5000
      })
    }
  }

  goLista(): void {
    this.router.navigateByUrl('administrativo/pre-cadastro/produto-pdm/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //##############################################
  // arquivos
  //##############################################
  arquivosLoadDados(): void {
    this.utilArquivo.empresa = '01',
    this.utilArquivo.filial  = '01',
    this.utilArquivo.arquivosLoadDados(this.fileAlias, this.fileChave);
    this.anexoPageSlide.open();
  }

  public readonly tabelaHistoricoColunas: Array<PoTableColumn> = [
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', label: 'Usuário'   , width: '15%', visible: true},
    {property: 'DDATA'                      , label: 'Data'      , width: '10%', visible: true, type: 'date', format: 'dd/MM/Y'},
    {property: 'CHORA'                      , label: 'Hora'      , width: '10%', visible: true},
    {property: 'CSTATUS' , width: '10%' , label: 'Status' , visible: true, type: 'label' ,
      labels: [
        { value: '2', color: 'color-01', label: 'Solicitante'},
        { value: '1', color: 'color-03', label: 'Engenharia'},
        { value: '4', color: 'color-04', label: 'Gerência Negado'},
        { value: '3', color: 'color-05', label: 'Compras'},
        { value: '6', color: 'color-06', label: 'Compras Negado'},
        { value: '5', color: 'color-07', label: 'Controladoria'},
        { value: '8', color: 'color-08', label: 'Controladoria Negado'},
        { value: '9', color: 'color-10', label: 'Finalizado'},
        { value: 'A', color: 'color-12', label: 'Cancelado'},
      ]
    },
    {property: 'COBSERVACAO'                , label: 'Observação', width: '55%', visible: true},
  ]

  get caracteristicas() : FormArray {
    return this.caracteristicasForm.get("items") as FormArray;
  }

  getNroComboCaracteristicas(): number {
    let num = 0;
    this.preProdutoPdm.ACARACTERISTICAS.map((item) => {
      num += item.CMODO == "S" ? 1 : 0;
    });
    return num;
  }

  onChangeNvl1() {
    if (this.contadorChanges - this.getNroComboCaracteristicas() >= 3) {
      this.filterZC1 = { CZC1CODZC0: this.preProdutoPdm.CGRPNVL1, combobox: 'S' };
      this.preProdutoPdm.CGRPNVL2 = '';
      this.preProdutoPdm.CB1XPDM = '';
    } else {
      this.contadorChanges += 1;
    }
  }

  onChangeNvl2() {
    if (this.contadorChanges - this.getNroComboCaracteristicas() >= 3) {
      this.filterZC2 = { CZC2CODZC1: this.preProdutoPdm.CGRPNVL2, combobox: 'S' };
      this.preProdutoPdm.CB1XPDM = '';
    } else {
      this.contadorChanges += 1;
    }
  }

  onChangePDM() {
    if (this.contadorChanges - this.getNroComboCaracteristicas() >= 3) {
      this.filterPDM = { CPDM: this.preProdutoPdm.CB1XPDM };
      this.filterPDMCombo = { CPDM: this.preProdutoPdm.CB1XPDM, combobox: 'S' };
      this.preProdutoPdm.CB1POSIPI = '';
      this.preProdutoPdm.CB1UM = '';
      this.preProdutoPdm.CB1SEGUM = '';
      this.pdmService.getCaracteristicas(this.preProdutoPdm.CB1XPDM).subscribe((ret) => {
        this.caracteristicas.clear();
        this.filterZC4 = []
        ret.items.map((item) => {
          this.caracteristicas.push(this.fb.group({...defaultCaracteristica(), ...item}));
          this.filterZC4.push({ CZC4CODZC2: this.preProdutoPdm.CB1XPDM, CZC4CODZC3: item.CCODCARACT });
        });
        this.contadorChanges = 3 + this.getNroComboCaracteristicas();
      });
    } else {
      this.contadorChanges += 1;
    }
  }

  onChangeCaracteristica(posicao: number): void {
    if (this.contadorChanges - this.getNroComboCaracteristicas() >= 3) {
      if(this.caracteristicas.value[posicao].CMODO == 'D') {
        this.caracteristicas.value[posicao].CDESCC = this.caracteristicas.value[posicao].CITEM;
        this.caracteristicas.value[posicao].CDESCL = this.caracteristicas.value[posicao].CITEM;

        this.atualizaDescricoes();
      } else {
        this.pdmService.getCaracteristicaItem(this.caracteristicas.value[posicao].CITEM).subscribe((item) => {
          this.caracteristicas.value[posicao].CDESCC = item.CZC4DESCC;
          this.caracteristicas.value[posicao].CDESCL = item.CZC4DESCL;
          this.caracteristicas.value[posicao].CUSADESC = item.CZC4CDESCS;

          this.atualizaDescricoes();
        });
      }
    } else {
      this.contadorChanges++;
    }
  }

  onChangeGrupo(): void {
    this.filterZAN = {combobox:'S', CZANCLASOL: '5', CZANGRUPO: this.preProdutoPdm.CB1GRUPO};;
  }

  atualizaDescricoes(): void {
    this.preProdutoPdm.LCHANGE = true;
    this.preProdutoPdm.CB1DESC = '';
    this.preProdutoPdm.CB1XDESCL = '';
    this.caracteristicas.value.map((item: Caracteristica) => {
      if (item.CITEM != '' && (item.CUSADESC == 'T' || item.CMODO == 'D')){
        this.preProdutoPdm.CB1DESC += item.CUSADESCC == 'S' ? `${item.CDESCC} ` : '';
        this.preProdutoPdm.CB1XDESCL += item.CUSADESCL == 'S' ? `${item.CCARACTERISTICA} ${item.CDESCL}; ` : `${item.CDESCL}; `;
      }
    });
    this.preProdutoPdm.CB1DESC = this.preProdutoPdm.CB1DESC.trim();
    this.preProdutoPdm.CB1XDESCL = this.preProdutoPdm.CB1XDESCL.trim();
  }

}
